import FEATURES from '../../../../../utils/featuresConstants'
import { debounce } from 'lodash'
import { getIsAi } from '../../../../../utils/sharedFeaturesFunctions'

export function isAICPT(coding_ai, features, cpt, mobileAICpt) {
  return (
    getIsAi() &&
    features?.includes(FEATURES.DesktopAI) &&
    cpt &&
    (coding_ai?.anthropic?.emcode === cpt ||
      mobileAICpt?.find((cptObject) => cptObject.code === cpt))
  )
}

export function isAIDiagnosis(coding_ai, codeCheckAI = [], features, dxCode) {
  return (
    getIsAi() &&
    features?.includes(FEATURES.DesktopAI) &&
    dxCode &&
    (coding_ai?.diagnosis_codes?.some((code) => code === dxCode) ||
      codeCheckAI?.some(
        (aiDx) => aiDx.code?.replace('.', '') === dxCode || aiDx?.replace?.('.', '') === dxCode,
      ))
  )
}

export function isPrimaryAIDiagnosis(coding_ai, features, dxCode, mobileAiDx = []) {
  return (
    getIsAi() &&
    features?.includes(FEATURES.DesktopAI) &&
    dxCode &&
    (coding_ai?.anthropic?.primarydx?.replace('.', '') === dxCode ||
      mobileAiDx?.includes(dxCode?.replace('.', '')))
  )
}

// we want the store to save constantly, BUT we dont want repetitive spam save visit calls
// so the debounce only calls every 500ms to tell the store to save to the DB
export const debouncer = debounce((funcToDebounce) => {
  funcToDebounce()
}, 500)
